/**
 * Prefix the pricing name with people quantity when shown (default).
 *
 * @param {string} name
 * @param {number|string} people
 * @param {boolean} [showPeople]
 * @returns {string}
 */
export default function formatPricingName(name, people, showPeople) {
    if (!name)
        return name || '';
    if (showPeople === false)
        return name;
    const qty = parseInt(people, 10);
    if (!Number.isFinite(qty) || qty <= 1)
        return name;
    return `${qty}x ${name}`;
}
